/**
 * Main App Component - Root component with routing and wishlist context
 */

import { Box, ContentBlock } from 'braid-design-system';
import type React from 'react';
import { Routes, Route } from 'react-router';

import { Footer } from '../components/Footer/Footer';
import { Header } from '../components/Header/Header';
import { CartProvider } from '../context/CartContext';
import { WishlistProvider } from '../context/WishlistContext';
import { routes } from '../routes';

import * as styles from './App.css';

export const App: React.FC = () => (
  <WishlistProvider>
    <CartProvider>
      <div className={styles.appContainer}>
        <Header />
        <ContentBlock width="large">
          <Box paddingX={{ mobile: 'small', wide: 'none' }}>
            <Routes>
              {routes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={route.element}
                />
              ))}
            </Routes>
          </Box>
        </ContentBlock>
        <Footer />
      </div>
    </CartProvider>
  </WishlistProvider>
);
